.rdo-configured-column-selector .dropdown-menu{max-height:50vh;overflow:auto;padding:5px 0;left:auto!important}
/*# sourceMappingURL=configured-column-selector.component-MUMP6PXL.css.map */
